export const L10N = {
  ACTION_SEARCH: { id: 'common.action.search' },
};
